import { cva } from 'class-variance-authority';

export const avatarVariants = cva(
  [
    'flex',
    'items-center',
    'justify-center',
    'rounded-radius-comp-avatar',
    'box-content',
    'relative',
    'outline',
    'outline-2',
    '[outline-offset:-2px]',
  ],
  {
    variants: {
      size: {
        tiny: [
          'w-sizing-comp-avatar-tiny',
          'h-sizing-comp-avatar-tiny',
          '[&>svg]:w-sizing-sys-size-16',
          '[&>svg]:h-sizing-sys-size-16',
        ],
        xsmall: [
          'w-sizing-comp-avatar-xsmall',
          'h-sizing-comp-avatar-xsmall',
          '[&>svg]:w-sizing-sys-size-16',
          '[&>svg]:h-sizing-sys-size-16',
        ],
        small: [
          'w-sizing-comp-avatar-small',
          'h-sizing-comp-avatar-small',
          '[&>svg]:w-sizing-sys-size-24',
          '[&>svg]:h-sizing-sys-size-24',
        ],
        medium: [
          'w-sizing-comp-avatar-medium',
          'h-sizing-comp-avatar-medium',
          '[&>svg]:w-sizing-sys-size-32',
          '[&>svg]:h-sizing-sys-size-32',
        ],
        large: [
          'w-sizing-comp-avatar-large',
          'h-sizing-comp-avatar-large',
          '[&>svg]:w-sizing-sys-size-40',
          '[&>svg]:h-sizing-sys-size-40',
        ],
        huge: [
          'w-sizing-comp-avatar-huge',
          'h-sizing-comp-avatar-huge',
          '[&>svg]:w-sizing-sys-size-64',
          '[&>svg]:h-sizing-sys-size-64',
        ],
      },
      variant: {
        strong: ['bg-color-comp-avatar-strong-container'],
        muted: ['bg-color-comp-avatar-muted-container'],
      },
      type: {
        letter: [],
        image: ['bg-cover', 'bg-center', 'bg-no-repeat'],
        icon: [],
      },
      border: {
        none: ['outline-color-comp-avatar-border-none'],
        neutral: ['outline-color-comp-avatar-border-neutral'],
        primary: ['outline-color-comp-avatar-border-primary'],
        warning: ['outline-color-comp-avatar-border-warning'],
        danger: ['outline-color-comp-avatar-border-danger'],
        success: ['outline-color-comp-avatar-border-success'],
      },
    },
    defaultVariants: {
      variant: 'strong',
      size: 'small',
      type: 'letter',
      border: 'none',
    },
  },
);
